import { Skeleton } from "@amazing-care/ui/skeleton";

/**
 * Stand-in for a page whose shape is not known yet: a code-split route still
 * downloading, or a role gate waiting on the profile.
 */
export function PageSkeleton() {
  return (
    <div className="mx-auto w-full max-w-5xl space-y-8" role="status" aria-label="Loading">
      <div className="space-y-2">
        <Skeleton className="h-8 w-56" />
        <Skeleton className="h-4 w-96 max-w-full" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[0, 1, 2].map((slot) => (
          <Skeleton key={slot} className="h-32 rounded-xl" />
        ))}
      </div>
      <div className="space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-11/12" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  );
}
